var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Auth, Layout, Dependencies } from "~/core/decorator";
import { State } from "vuex-class";
import { OutsourceSettlevOucherService } from "~/services/domain-service/outsource-settle-manage-index.service";
import { OutsourceSettleManageService } from "~/services/domain-service/outsource-settle-manage.service";
import { PageService } from '~/utils/page.service';
import { SortService } from '~/utils/sort.service';
import modifyManage from '~/components/outsource-manage/outsource-settle-manage/modify-manage.vue';
var OutsourceSettleManageIndex = /** @class */ (function (_super) {
    __extends(OutsourceSettleManageIndex, _super);
    function OutsourceSettleManageIndex() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dialog = {
            modifyManage: false
        };
        _this.selectionList = [];
        // form 查询表单参数
        _this.queryModel = {
            outsName: '',
            outBatch: '',
            date: [],
        };
        _this.outsNames = []; //受托方列表
        _this.dataList = [];
        _this.caseRow = {}; //查看或编辑某一条row
        return _this;
    }
    OutsourceSettleManageIndex.prototype.mounted = function () {
        this.refreshData();
    };
    /**
     * 查询列表
     */
    OutsourceSettleManageIndex.prototype.refreshData = function () {
        var _this = this;
        this.outsourceSettlevOucherService.
            getCaseSettlementSheetPageList(this.queryModel, this.pageService, this.sortService)
            .subscribe(function (data) {
            _this.dataList = data;
            _this.selectionList = [];
        });
    };
    /**
     * 导出委外对账单
     */
    OutsourceSettleManageIndex.prototype.clickExport = function () {
        var _this = this;
        //需要导出的列表 ids
        var ids = this.selectionList.map(function (v) { return v.id; });
        if (ids.length === 0) {
            this.$message.info('请选择要导出的结算单');
            return;
        }
        this.outsourceSettlevOucherService.
            exportSettlementSheet({ ids: ids })
            .subscribe(function (data) {
            _this.$message.success("导出成功!");
            window.open(data.url);
        });
    };
    OutsourceSettleManageIndex.prototype.checkDetail = function (scope) {
        this.dialog.modifyManage = true;
        this.caseRow = scope.row;
    };
    __decorate([
        Dependencies(OutsourceSettlevOucherService)
    ], OutsourceSettleManageIndex.prototype, "outsourceSettlevOucherService", void 0);
    __decorate([
        Dependencies(PageService)
    ], OutsourceSettleManageIndex.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], OutsourceSettleManageIndex.prototype, "sortService", void 0);
    __decorate([
        Dependencies(OutsourceSettleManageService)
    ], OutsourceSettleManageIndex.prototype, "OutsourceSettleManageService", void 0);
    __decorate([
        State
    ], OutsourceSettleManageIndex.prototype, "outSourceList", void 0);
    OutsourceSettleManageIndex = __decorate([
        Auth(1008),
        Layout("workspace"),
        Component({
            components: {
                modifyManage: modifyManage
            }
        })
    ], OutsourceSettleManageIndex);
    return OutsourceSettleManageIndex;
}(Vue));
export default OutsourceSettleManageIndex;
